module.exports = __webpack_public_path__ + "static/media/shop-3.5d31d141.jpg";